import { createRouter, createWebHistory } from 'vue-router'
import Index from '@/pages/Index.vue'
import Home from '@/pages/Home.vue'
import Acceptnotification from '@/pages/Acceptnotification.vue'
import Login from '@/pages/Login.vue'
import Updateavailable from '@/pages/Updateavailable.vue'
import Welcome from '@/pages/Welcome.vue'
import Orders from '@/pages/Orders.vue'
import Payments from '@/pages/Payments.vue'
import Customers from '@/pages/Customers.vue'
import Riders from '@/pages/Riders.vue'
import Chat from '@/pages/Chat.vue'
import ProSubscription from '@/pages/ProSubscription.vue'
import AccountValidation from '@/pages/AccountValidation.vue'
import DailyDeals from '@/pages/DailyDeals.vue'
import Stores from '@/pages/Stores.vue'
import StoreDetail from '@/pages/StoreDetail.vue'
import StoreStats from '@/components/store/StoreStats.vue'
import WithdrawalsListBank from '@/components/withdrawal/WithdrawalsListBank.vue'
import WithdrawalsListMomo from '@/components/withdrawal/WithdrawalsListMomo.vue'
import Documents from '@/pages/Documents.vue'
import TopProducts from '@/pages/TopProducts.vue'
import Team from '@/pages/Team.vue'
import Fees from '@/pages/Fees.vue'
import Categories from '@/pages/Categories.vue'
import Website from '@/pages/Website.vue'
import Configurations from '@/pages/Configurations.vue'
import Chargebacks from '@/pages/Chargebacks.vue'
import Products from '@/pages/Products.vue'
import StoreProducts from '@/components/store/StoreProducts.vue'
// import ProductsView from '@/views/ProductsView.vue'
// import ProductDetails from '@/views/ProductDetails.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
    },
    {
      path: '/stores',
      name: 'stores',
      component: Stores,
    },
    {
      path: '/stores/:storeId',
      component: StoreDetail,
      name: 'storeDetails',
      children: [
        {
          name: 'storeStats',
          path: '',
          component: StoreStats,
        },
        {
          name: 'storeProducts',
          path: 'products',
          component: StoreProducts,
        },
      ],
    },
    {
      path: '/orders',
      name: 'orders',
      component: Orders,
    },
    {
      path: '/chargebacks',
      name: 'chargebacks',
      component: Chargebacks,
    },
    {
      path: '/top-products',
      name: 'top-products',
      component: TopProducts,
    },
    {
      path: '/products',
      name: 'products',
      component: Products,
    },
    {
      path: '/payments',
      name: 'payments',
      component: Payments,
    },
    {
      path: '/customers',
      name: 'customers',
      component: Customers,
    },
    {
      path: '/riders',
      name: 'riders',
      component: Riders,
    },
    {
      path: '/deals',
      name: 'deals',
      component: DailyDeals,
    },
    {
      path: '/team',
      name: 'team',
      component: Team,
    },
    {
      path: '/chat',
      name: 'chat',
      component: Chat,
    },
    {
      path: '/fees',
      name: 'fees',
      component: Fees,
    },
    {
      path: '/categories',
      name: 'categories',
      component: Categories,
    },
    {
      path: '/website',
      name: 'website',
      component: Website,
    },
    {
      path: '/configurations',
      name: 'configurations',
      component: Configurations,
    },
    {
      path: '/acceptnotification',
      name: 'acceptnotification',
      component: Acceptnotification,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    // {
    //   path: '/register',
    //   name: 'register',
    //   component: Register,
    // },
    {
      path: '/updateavailable',
      name: 'updateavailable',
      component: Updateavailable,
    },
    {
      path: '/welcome',
      name: 'welcome',
      component: Welcome,
    },
    {
      path: '/googleLogin/done',
      name: 'googleLoginDone',
      component: Welcome,
    },
    {
      path: '/validation',
      name: 'accountValidation',
      component: AccountValidation,
    },
    {
      path: '/pro',
      name: 'proSubscription',
      component: ProSubscription,
    },
    {
      path: '/withdrawal',
      name: 'withdrawal',
      component: WithdrawalsListBank,
    },
    {
      path: '/transfer',
      name: 'transfer',
      component: WithdrawalsListMomo,
    },
    {
      path: '/documents',
      name: 'documents',
      component: Documents,
    },
    // { path: '/category/:categoryId', component: ProductsView },
    // { path: '/product/:productId', component: ProductDetails },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (About.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import('../views/AboutView.vue'),
    // },
  ],
  scrollBehavior(to, from, savedPosition) {
    // console.log(to)
    // always scroll to top
    return { top: 0 }
  },
})

export default router
